import { FilterTypeCheckboxModel } from '../../../Common/Filter/models/filter-type-checkbox.model';
import { DistributionStatus } from '../../../Common/TargetingShared/enum/distribution-status.enum';
import { SearchModeEnum } from '../../../Common/TargetingShared/enum/search-mode.enum';
import { TargetedListTypesEnum } from '../../../Common/TargetingShared/enum/targeted-list-types.enum';
import { TargetingFiltersEnum } from '../../../Common/TargetingShared/enum/targeting-filters.enum';
import { AuditableFiltersModel } from '../../../Common/Filter/models/auditable-filters.model';
import { FilterTypeModel } from '../../../Common/Filter/models/abstract-filter-type.model';
import {
    UserAppPreferenceSavedSearchesFilters,
    UserAppPreferenceTargetedListsFilters,
    UserAppPreferenceDistributionsFilters,
    UserAppPreferenceCommonFilters
} from '../../../Core/Users/models/user-app-preferences-filters.model';

export class DiscoverSavedSearchesDisplayFilterModel extends AuditableFiltersModel {
    private static readonly SEARCH_TYPE_ID = 'searchType';
    private readonly searchTypeFilter = new FilterTypeCheckboxModel<SearchModeEnum>(
        DiscoverSavedSearchesDisplayFilterModel.SEARCH_TYPE_ID,
        'Discover.leftSidebar.filter.searchType',
        [
            {
                label: 'Discover.leftSidebar.filter.searchType.option.contact',
                value: SearchModeEnum.contact
            },
            {
                label: 'Discover.leftSidebar.filter.searchType.option.outlet',
                value: SearchModeEnum.outlet
            }
        ]
    );

    protected filterValues: UserAppPreferenceSavedSearchesFilters;

    constructor(filters: UserAppPreferenceSavedSearchesFilters) {
        super(filters);
        this.searchTypeFilter.setValue(filters.type);
        this.filterValues = {
            ...this.auditableValues,
            type: filters.type
        };
    }

    getAllFilters(): FilterTypeModel<any>[] {
        return [this.searchTypeFilter];
    }

    public setAllFilters(filtersToSet: FilterTypeModel<any>[], filterValues: UserAppPreferenceSavedSearchesFilters) {
        filtersToSet.find(filter => filter.id === 'name').label = 'UserPreferences.savedSearchName';
        super.setAuditableFilters(filtersToSet, filterValues);
        this.searchTypeFilter.setValue(filterValues.type);
    }

    public setNewValues(newFilters: FilterTypeModel<any>[]) {
        super.setNewAuditableFilterValues(newFilters);
        this.filterValues = {
            ...this.auditableValues,
            type: newFilters.find(filter => filter.id === DiscoverSavedSearchesDisplayFilterModel.SEARCH_TYPE_ID)?.getValue()
        };
    }

    public getFilterValues(): UserAppPreferenceSavedSearchesFilters {
        return {
            ...super.getAuditableFilterValues(),
            type: this.filterValues.type
        };
    }
}

export class DiscoverTargetedListsDisplayFilterModel extends AuditableFiltersModel {
    private static readonly LIST_TYPE_ID = 'listType';
    private readonly listTypeFilter = new FilterTypeCheckboxModel<TargetedListTypesEnum>(
        DiscoverTargetedListsDisplayFilterModel.LIST_TYPE_ID,
        'Discover.leftSidebar.filter.listType',
        [
            {
                label: 'Discover.leftSidebar.filter.listType.option.both',
                value: TargetedListTypesEnum.both
            },
            {
                label: 'Discover.leftSidebar.filter.listType.option.contact',
                value: TargetedListTypesEnum.contact
            },
            {
                label: 'Discover.leftSidebar.filter.listType.option.outlet',
                value: TargetedListTypesEnum.outlet
            }
        ]
    );

    protected filterValues: UserAppPreferenceTargetedListsFilters;

    constructor(filters: UserAppPreferenceTargetedListsFilters) {
        super(filters);
        this.listTypeFilter.setValue(filters.type);
        this.filterValues = {
            ...this.auditableValues,
            type: filters.type
        };
    }

    getAllFilters(): FilterTypeModel<any>[] {
        return [this.listTypeFilter];
    }

    public setAllFilters(filtersToSet: FilterTypeModel<any>[], filterValues: UserAppPreferenceTargetedListsFilters) {
        filtersToSet.find(filter => filter.id === 'name').label = 'UserPreferences.targetedListName';
        super.setAuditableFilters(filtersToSet, filterValues);
        this.listTypeFilter.setValue(filterValues.type);
    }

    public setNewValues(newFilters: FilterTypeModel<any>[]) {
        super.setNewAuditableFilterValues(newFilters);
        this.filterValues = {
            ...this.auditableValues,
            type: newFilters.find(filter => filter.id === DiscoverTargetedListsDisplayFilterModel.LIST_TYPE_ID)?.getValue()
        };
    }

    public getFilterValues(): UserAppPreferenceTargetedListsFilters {
        return {
            ...super.getAuditableFilterValues(),
            type: this.filterValues.type
        };
    }
}

export class DiscoverDistributionsDisplayFilterModel extends AuditableFiltersModel {
    private static readonly STATUS_ID = TargetingFiltersEnum.status;
    private readonly deliveryStatusFilter = new FilterTypeCheckboxModel<DistributionStatus>(
        DiscoverDistributionsDisplayFilterModel.STATUS_ID,
        'Discover.targeting.filter.status',
        [
            {
                label: 'Discover.deliveryStatusFilter.draft',
                value: DistributionStatus.draft
            },
            {
                label: 'Discover.deliveryStatusFilter.scheduled',
                value: DistributionStatus.scheduled
            },
            {
                label: 'Discover.deliveryStatusFilter.sent',
                value: DistributionStatus.sent
            },
            {
                label: 'Discover.deliveryStatusFilter.failed',
                value: DistributionStatus.failed
            },
        ]
    );


    protected filterValues: UserAppPreferenceDistributionsFilters;

    constructor(filters: UserAppPreferenceDistributionsFilters) {
        super(filters);
        this.deliveryStatusFilter.setValue(filters.status);
        this.filterValues = {
            ...this.auditableValues,
            status: filters.status
        };
    }

    getAllFilters(): FilterTypeModel<any>[] {
        return [this.deliveryStatusFilter];
    }

    public setAllFilters(filtersToSet: FilterTypeModel<any>[], filterValues: UserAppPreferenceDistributionsFilters) {
        filtersToSet.find(filter => filter.id === 'name').label = 'UserPreferences.distributionName';
        super.setAuditableFilters(filtersToSet, filterValues);
        this.deliveryStatusFilter.setValue(filterValues.status);
    }

    public setNewValues(newFilters: FilterTypeModel<any>[]) {
        super.setNewAuditableFilterValues(newFilters);
        this.filterValues = {
            ...this.auditableValues,
            status: newFilters.find(filter => filter.id === DiscoverDistributionsDisplayFilterModel.STATUS_ID)?.getValue()
        };
    }

    public getFilterValues(): UserAppPreferenceDistributionsFilters {
        return {
            ...super.getAuditableFilterValues(),
            status: this.filterValues.status
        };
    }
}
